import cn from 'classnames';
import Link from 'next/link';
import { ScreenSizeOptionT } from '@/components/v2/product/hooks/types';

const ScreenSizeOption = ({
  option,
  className,
}: {
  option: ScreenSizeOptionT;
  className?: string;
}) => (
  <div className={cn(className, 'relative')}>
    <Link
      href={`/collections/${encodeURIComponent(option.slug)}`}
      scroll={false}
      id={`e2e-pdp-screenSize-${option.screenSize}`}
      aria-current={option.isSelected ? 'page' : undefined}
      className={cn(
        'flex h-10 flex-col items-center justify-center rounded border px-2 leading-none focus:outline-none',
        {
          'border-gray-700 font-bold': option.isSelected,
          'border-gray-700/25 hover:border-gray-700': !option.isSelected,
        },
      )}
    >
      <span>{option.screenSize}</span>
    </Link>
  </div>
);

export default ScreenSizeOption;
